
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-details",
      function () {
        return require("private-next-pages/company-details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-details"])
      });
    }
  